export default __webpack_public_path__ + "static/media/SubaruNonLP.138ef263.png";